import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Typography,
  Theme,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { BooleanInput, useTranslate } from "react-admin";
import { useTheme } from "@material-ui/styles";
import { useForm } from "react-final-form";
import { RootActionPermissionGroup } from "../../../../common/data/service-proxies";

interface ActionPermissionsGroupTabProps {
  group: RootActionPermissionGroup;
}

export const ActionPermissionsGroupTab = ({
  group,
  ...rest
}: ActionPermissionsGroupTabProps) => {
  const translate = useTranslate();
  const theme: Theme = useTheme();
  const form = useForm();

  if (!group?.permissionGroups) {
    return null;
  }

  return (
    <Box>
      {group.permissionGroups.map((permissionGroup, permissionGroupIndex) => {
        if (!permissionGroup?.permissions) {
          return null;
        }

        return (
          <Accordion key={permissionGroupIndex}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label="Expand"
              aria-controls={`permission-group${
                permissionGroupIndex + 1
              }-content`}
              id={`permission-group${permissionGroupIndex + 1}-header`}
            >
              <Typography
                variant="body2"
                style={{ color: theme.palette.primary.main }}
              >
                {translate(
                  `permissions.${permissionGroup.permissionGroupDisplayName}`
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              className="ra-input form-accordion"
              style={{ flexDirection: "column" }}
            >
              <BooleanInput
                {...rest}
                source={`actionPermissions.${permissionGroup.permissionGroup}.isGranted`}
                label="permissions.Access"
                onChange={(value: boolean) => {
                  if (!value) {
                    for (const permission of permissionGroup.permissions!) {
                      form.change(
                        `actionPermissions.${permission.name}.isGranted`,
                        false
                      );
                    }
                  }
                }}
              />
              {permissionGroup.permissions.map(
                (permission, permissionIndex) => {
                  return (
                    <BooleanInput
                      {...rest}
                      key={permissionIndex}
                      source={`actionPermissions.${permission.name}.isGranted`}
                      label={`permissions.${permission.displayName}`}
                      style={{ marginLeft: "1rem" }}
                      onChange={(value: boolean) => {
                        if (value !== undefined) {
                          form.change(
                            `actionPermissions.${permissionGroup.permissionGroup}.isGranted`,
                            true
                          );
                        }
                      }}
                    />
                  );
                }
              )}
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box> /*  : (
    <Box>
      {from(group.group.permissions!)
        .groupBy((x) => x.name!.split(".")[0])
        .select((x, index) => (
          <Accordion key={index}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-label="Expand"
              aria-controls={`permission-group${index + 1}-content`}
              id={`permission-group${index + 1}-header`}
            >
              <Typography
                variant="body2"
                style={{ color: theme.palette.primary.main }}
              >
                {translate(`permissions.${x.key}`)}
              </Typography>
            </AccordionSummary>
            <AccordionDetails
              style={{ flexDirection: "column" }}
              className="ra-input form-accordion"
            >
              {x.select((permission, permissionIndex) => {
                return (
                  <BooleanInput
                    {...rest}
                    key={permissionIndex}
                    source={`actionPermissions[${permission.name}].isGranted`}
                    label={`permissions.${permission.displayName}`}
                  />
                );
              })}
            </AccordionDetails>
          </Accordion>
        ))}
    </Box>
  ) */
  );
};
